// extracted by mini-css-extract-plugin
export default {"column":"Column_column__X5lsa","cardsWrapper":"Column_cardsWrapper__E13XH"};